import React from 'react';
import { Link } from 'react-router-dom';
import img1 from '../../Assets/Screenshot (38).png';
import img2 from '../../Assets/Screenshot (41).png';
import img3 from '../../Assets/Screenshot (42).png';

const Projects = () => {
    return (
        <div>
            <h2 className='text-5xl font-serif font-bold mt-8 underline ml-10 text-black'>My Complete Projects</h2>

            <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8'>
                <div className="mt-10 rounded-lg shadow-lg bg-sky-100 ">
                    <img src={img1} alt="" className="object-cover object-center w-full rounded-t-md h-72 " />
                    <div className="flex flex-col justify-between p-6 space-y-8">
                        <div className="space-y-2">
                            <h2 className="text-3xl text-black font-semibold tracking-wide">EduCine</h2>
                            <p className="text-gray-600">A Learning Website</p>
                        </div>
                        <Link to='/project1' type="button" className="flex items-center justify-center w-full p-3 font-semibold tracking-wide  rounded-full bg-gradient-to-r from-slate-900 via-purple-900 to-slate-900 text-white">Read more</Link>
                    </div>
                </div>
                <div className="mt-10 rounded-md shadow-lg bg-sky-100 ">
                    <img src={img2} alt="" className="object-cover object-center w-full rounded-t-md h-72 " />
                    <div className="flex flex-col justify-between p-6 space-y-8">
                        <div className="space-y-2">
                            <h2 className="text-3xl text-black font-semibold tracking-wide">Phone Garage</h2>
                            <p className="text-gray-600">A Phone Buy and Sell Website</p>
                        </div>
                        <Link to='/project2' type="button" className="flex items-center justify-center w-full p-3 font-semibold tracking-wide  rounded-full bg-gradient-to-r from-slate-900 via-purple-900 to-slate-900 text-white">Read more</Link>
                    </div>
                </div>
                <div className="mt-10 rounded-md shadow-lg bg-sky-100 ">
                    <img src={img3} alt="" className="object-cover object-center w-full rounded-t-md h-72 " />
                    <div className="flex flex-col justify-between p-6 space-y-8">
                        <div className="space-y-2">
                            <h2 className="text-3xl text-black font-semibold tracking-wide">Dream World</h2>
                            <p className="text-gray-600">A Photography Website</p>
                        </div>
                        <Link to='/project3' type="button" className="flex items-center justify-center w-full p-3 font-semibold tracking-wide  rounded-full bg-gradient-to-r from-slate-900 via-purple-900 to-slate-900 text-white">Read more</Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Projects;